import type { TourModule } from '@modules/product-updates/tours/tourTypes';

export const WHATS_NEW_BELL_ANCHOR = 'notification-bell';

// One step on the top-bar bell, played once by the campaign implied by
// `content/releases/whats-new` (see `NotificationBell.tsx`).
export const whatsNewBellTour: TourModule = {
  steps: t => [
    {
      anchor: WHATS_NEW_BELL_ANCHOR,
      title: t("Notifications and what's new"),
      body: t(
        'Your notifications and every update to the CRM are now here. Updates come with guided tours you can replay at any time.',
      ),
      placement: 'bottom-end',
    },
  ],
};
